/*
 * @Author: 小周
 * @Date: 2023-09-07 11:20:46
 * @LastEditTime: 2024-08-02 11:11:03
 * @LastEditors: MrZHLF
 * @Description:
 */
import { useState, useEffect, useRef } from 'react'

import styles from './appNavBar.module.scss'
import { getDevice } from '@utils/index'
import { openAppMenu, openApp } from '@/utils/openApp'
import useGetDeviceType from '../../hooks/useGetDeviceType'
import { ARTICLE_ID } from '@/constant/index'
function AppNavBar(props) {
  const [isShow, setIsShow] = useState(false)
  const [extinfo, setExtinfo] = useState({})
  const [wxOpenBtn, setWxOpenBtn] = useState('none')
  const openTagRef = useRef(null)

  const { deviceType } = useGetDeviceType()

  useEffect(() => {
    if (props && props.appPath) {
      // 唤醒菜单栏
      setExtinfo({
        redirectPath: props.redirectPath,
        msgType: props.msgType,
        isJumpApp: true,
      })
    } else if (props && props.isArticle) {
      // 唤醒文章
      setExtinfo({
        id: props.articleId,
        msgType: props.msgType,
        isJumpApp: true,
      })
    } else {
      // 外链
      setExtinfo({
        id: ARTICLE_ID,
        msgType: props.msgType,
        isJumpApp: true,
      })
    }
    let device = getDevice()
    if (device.includes('android') && device.includes('wechat')) {
      setWxOpenBtn('block')
      setIsShow(true)
    } else {
      setWxOpenBtn('none')
      setIsShow(false)
    }
  }, [props])

  function handleOpenApp() {
    if (props.appPath) {
      // 打开App底部菜单栏
      openAppMenu(props.msgType, props.redirectPath)
    } else if (props.isArticle) {
      //打开App指定文章
      openApp(props.articleId, props.msgType)
    } else {
      // 外链文章
      openApp(ARTICLE_ID, props.msgType)
    }
  }

  if (deviceType) {
    return null
  }

  return (
    <>
      <div className={styles.appWrapper}>
        <div className={styles.headerL}>
          <img
            src="https://res.hntv.tv/icon/logo.png"
            className={styles.logo}
            alt=""
          />
          <div className={styles.info}>
            <p className={styles.infoTitle}>大象新闻APP</p>
            <p>脚踏实地做新闻</p>
          </div>
        </div>
        <div className={styles.headerBtn}>
          <button className={styles.btn} onClick={() => handleOpenApp()}>
            打开
          </button>
          {isShow ? (
            <wx-open-launch-app
              id="launch-btn"
              ref={openTagRef}
              class={styles.openTag}
              style={{
                display: `${wxOpenBtn}`,
              }}
              appid="wx5dc84714dd7219dd"
              extinfo={JSON.stringify(extinfo)}
            >
              <script type="text/wxtag-template">
                <div
                  style={{
                    position: 'absolute',
                    width: '100%',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                  }}
                ></div>
              </script>
            </wx-open-launch-app>
          ) : null}
        </div>
      </div>
      <div className={styles['top-header']}></div>
    </>
  )
}

export default AppNavBar
